export { Modal as default } from './Modal';
